module.exports = __webpack_public_path__ + "static/media/IMG_20200417_185749.d4980d83.jpg";